module.exports = __webpack_public_path__ + "static/img/culture-value.bd5ef9cd.png";